(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["signtasy-business-gallery"] && !Shopify.designMode) return;
  try {
    (()=>{
  const boot=(scope=document)=>scope.querySelectorAll('[data-sgb-gallery]').forEach(gallery=>{
    if(gallery.dataset.ready)return;
    gallery.dataset.ready='true';
    const abort=new AbortController(),buttons=[...gallery.querySelectorAll('[data-gallery-choice]')],image=gallery.querySelector('.sgb-gallery-image'),stage=gallery.querySelector('.sgb-gallery-stage'),label=gallery.querySelector('[data-gallery-label]'),error=gallery.querySelector('[data-gallery-error]');
    if(!image)return;
    const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:abort.signal});
    const loaded=()=>{stage.removeAttribute('aria-busy');error.hidden=true;image.hidden=false;};
    const failed=()=>{stage.removeAttribute('aria-busy');error.hidden=false;image.hidden=true;};
    on(image,'load',loaded);on(image,'error',failed);
    if(image.complete&&!image.naturalWidth)failed();
    const select=button=>{
      if(!button)return;
      stage.setAttribute('aria-busy','true');error.hidden=true;image.hidden=false;
      buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      label.textContent=button.dataset.galleryLabel;image.alt=button.dataset.galleryAlt;
      image.srcset=button.dataset.gallerySrcset;image.src=button.dataset.gallerySrc;
      gallery.dataset.galleryKey=button.dataset.galleryChoice;
      if(image.complete){if(image.naturalWidth)loaded();else failed();}
    };
    buttons.forEach((button,index)=>{
      on(button,'click',()=>select(button));
      on(button,'keydown',event=>{
        let next;
        if(event.key==='ArrowRight')next=(index+1)%buttons.length;
        if(event.key==='ArrowLeft')next=(index+buttons.length-1)%buttons.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=buttons.length-1;
        if(next===undefined)return;
        event.preventDefault();buttons[next].focus({preventScroll:true});select(buttons[next]);
        buttons[next].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      });
    });
    const requested=new URL(location.href).searchParams.get('concept');
    const initial=buttons.find(button=>button.dataset.galleryChoice===requested);
    if(initial)select(initial);
    on(document,'shopify:section:unload',event=>{if(event.target.contains(gallery))abort.abort();});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signtasy-home-details"] && !Shopify.designMode) return;
  try {
    (()=>{
 const boot=(scope=document)=>scope.querySelectorAll('[data-home-details]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const home=root.closest('[data-sg-root]');
  if(!home)return;
  const abort=new AbortController();
  const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:abort.signal});
  const $=s=>root.querySelector(s);
  const labels={...$('[data-sgi-labels]').dataset,...$('[data-sgi-batch-labels]').dataset};
  const dialog=$('.sgi-dialog'),main=$('[data-sgi-main]'),grid=$('.sgi-dialog-grid');
  const loading=$('[data-home-detail-loading]'),error=$('[data-home-detail-error]');
  let cards=[],designs=new Map(),current=null,opener=null,previousOverflow='',sequence=0,loadPromise=null;
  const route=href=>{
   const url=new URL(href,location.href),here=new URL(location.href);
   if(url.origin===here.origin)for(const key of ['preview_theme_id','_ab','_fd','_sc'])if(here.searchParams.has(key))url.searchParams.set(key,here.searchParams.get(key));
   return url;
  };
   const fonts={"barcelony":"Barcelony","black-jack":"BlackJack","hesterica":"Hesterica","nickainley":"Nickainley Normal","shutter-stone":"Shutter Stone Standard","brittany-signature":"Brittany Signature","quinzey":"Quinzey","retro-signature":"Retro Signature","richardson-script":"Richardson Script DEMO","romate-hood":"Romate Hood","great-vibes":"Great Vibes","allura":"Allura","sacramento":"Sacramento","windsong":"WindSong","oooh-baby":"Oooh Baby","parisienne":"Parisienne","outfit":"Outfit","grape-nuts":"Grape Nuts","barlow-condensed":"Barlow Condensed","dancing-script":"Dancing Script","alex-brush":"Alex Brush","kristi":"Kristi","kaushan-script":"Kaushan Script"};
  const captionCopy=value=>String(value||'').replace(/\s*[·|—–-]?\s*AI(?:-generated)?(?: design)? concept\s*$/i,'').trim();
  const sizeCopy=value=>String(value||'').replace(/\b(?:approximately|approx\.?|estimated)\s*/gi,'').replace(/^\s*(?:大约|约|估算)\s*/u,'').trim();
  const sizeOf=d=>{
   const width=Number(d.width),height=Number(d.height),confirmed=d.sizeConfirmed==='true'&&Number.isFinite(width)&&Number.isFinite(height)&&width>0&&height>0;
   return {width,height,unit:d.unit==='in'?'in':'cm',confirmed,label:confirmed?`${width} × ${height} ${d.unit==='in'?'in':'cm'}`:(sizeCopy(d.sizeReference)||labels.pending)};
  };
  const encode=value=>{const bytes=new TextEncoder().encode(JSON.stringify(value));return btoa(Array.from(bytes,b=>String.fromCharCode(b)).join('')).replaceAll('+','-').replaceAll('/','_').replace(/=+$/,'');};
  const transfer=d=>{
   const icon=["heart","star","moon","sun","cloud","zap","music","flower2","crown","infinity","smile","paw","flame","diamond","leaf","wine","coffee","cake","gamepad","sparkles","gem","plane","umbrella","gift","rocket","daisy","ice-cubes"].includes(d.icon)?d.icon:'none';
   const action=$('[data-sgi-customize]');action.textContent=labels.customize+' →';
   if(d.designMode==='enquiry'&&icon==='none'){
    const enquiry=route(d.enquiryUrl||root.dataset.customizer);if(!d.enquiryUrl)enquiry.searchParams.set('design_help','1');enquiry.searchParams.set('source','inspiration-artwork');
    action.href=enquiry.href;action.textContent=labels.enquire+' →';$('[data-sgi-customize-help]').textContent=labels.enquiryHelp;return;
   }
   const size=sizeOf(d),widthCm=size.unit==='in'?size.width*2.54:size.width;
   const state={text:d.presetText||d.text,layout:d.layout,color:d.color,colorMode:'whole',letterColors:[],room:d.category==='weddings'?'wedding':current.dataset.scene==='bedroom'?'bedroom':current.dataset.scene==='gaming_setup'?'gaming':'living',positions:{},icon,iconSize:Math.min(65,Math.max(20,Number(d.iconSize)||35)),iconPosition:['left','right','top','bottom'].includes(d.iconPosition)?d.iconPosition:'right',iconColor:d.iconColor||'inherit',powered:true,rowGap:100,rowOffset:0,stage:'design',step:0};
   if(icon!=='none')Object.assign(state,{backing:'shape',backingColor:'clear',installation:'wall'});
   const notes=[];
   if(["barcelony","nickainley","shutter-stone","brittany-signature","quinzey","retro-signature","richardson-script","romate-hood","great-vibes","allura","sacramento","windsong","oooh-baby","parisienne","outfit","barlow-condensed","cookie","courgette","dancing-script","jost","kaushan-script","marck-script","mr-dafoe","norican","satisfy","yellowtail","patrick-hand"].includes(d.font))state.font=d.font;else notes.push(labels.fontPending);
   if((size.confirmed||icon!=='none')&&Number.isFinite(widthCm)&&widthCm>=40&&widthCm<=160){state.width=Math.round(widthCm*10)/10;state.unit=size.unit;}else notes.push(size.confirmed?labels.sizeRange:labels.sizePending);
   const url=route(root.dataset.customizer);url.searchParams.set('source','inspiration');
   if(notes.length)url.searchParams.set('inspiration_note',notes.join(' '));
   if(size.confirmed)url.searchParams.set('reference_size',size.label);
   url.hash='design='+encode({format:'signtasy-design',version:1,state});
   const link=$('[data-sgi-customize]');link.href=url.href;
   $('[data-sgi-customize-help]').textContent=notes.length?notes.join(' '):labels.helper;
  };
  const thumbnail=(card,related=false)=>{
   const button=document.createElement('button');button.type='button';button.dataset.photo=card.dataset.photo;
   button.setAttribute('aria-label',captionCopy(card.dataset.caption));button.setAttribute('aria-pressed',String(card===current));
   const img=document.createElement('img');img.src=card.dataset.thumb;img.alt='';img.width=112;img.height=140;img.loading='lazy';button.append(img);
   if(related){const caption=document.createElement('span');caption.textContent=captionCopy(card.dataset.caption);button.append(caption);}
   button.addEventListener('click',()=>showPhoto(card),{signal:abort.signal});return button;
  };
  const showPhoto=card=>{
   current=card;const d=designs.get(card.dataset.design),same=cards.filter(c=>c.dataset.design===card.dataset.design);
   main.alt=captionCopy(card.dataset.alt);main.style.opacity='0';main.src=card.dataset.full;main.decode().then(()=>{if(current===card)main.style.opacity='1';}).catch(()=>{if(current===card)main.style.opacity='1';});$('[data-sgi-photo-error]').hidden=true;
   $('[data-sgi-title]').textContent=d.title;$('[data-sgi-scene-name]').textContent=captionCopy(card.dataset.caption);$('[data-sgi-category-name]').textContent=labels[d.category];
   $('[data-sgi-value="text"]').textContent=d.text.replace(/\n/g,' ');
   $('[data-sgi-value="font"]').textContent=d.fontLabel||fonts[d.font]||labels.pending;
   $('[data-sgi-value="color"]').textContent=d.colorLabel;$('[data-sgi-swatch]').style.background=d.swatch;
   $('[data-sgi-value="layout"]').textContent=d.layoutLabel||labels[d.layout];$('[data-sgi-value="size"]').textContent=sizeOf(d).label;
   $('[data-sgi-construction]').hidden=!d.backing;
   for(const key of ['backing','mounting'])$('[data-sgi-value="'+key+'"]').textContent=d[key]||'';
   $('[data-sgi-size-note]').textContent=sizeCopy(d.sizeNote);
   $('[data-sgi-size-note]').hidden=!sizeCopy(d.sizeNote);
   $('[data-sgi-thumbs]').replaceChildren(...same.map(c=>thumbnail(c)));$('[data-sgi-thumbs]').hidden=same.length<2;$('.sgi-related').hidden=same.length<2;
   $('[data-sgi-related]').replaceChildren(...same.filter(c=>c!==card).slice(0,2).map(c=>thumbnail(c,true)));
   transfer(d);
  };

  const load=()=>{
   if(loadPromise)return loadPromise;
   const request=new AbortController(),cancel=()=>request.abort();
   abort.signal.addEventListener('abort',cancel,{once:true});
   const timer=setTimeout(cancel,15000);
   loadPromise=(async()=>{
    const response=await fetch(route(root.dataset.gallery),{signal:request.signal,credentials:'same-origin'});
    if(!response.ok)throw new Error('Details unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const gallery=doc.querySelector('[data-inspiration-root]');
    if(!gallery)throw new Error('Missing inspiration gallery');
    const sources=[gallery,...[...doc.querySelectorAll('template[data-sgi-extra]')].map(t=>t.content)];
    const data=new Map(sources.flatMap(s=>[...s.querySelectorAll('[data-sgi-design]')]).map(el=>[el.dataset.sgiDesign,{...el.dataset}]));
    const photos=sources.flatMap(s=>[...s.querySelectorAll('[data-sgi-card]')]);
    if(!photos.length||!data.size)throw new Error('Empty inspiration gallery');
    return {data,photos};
   })().catch(e=>{loadPromise=null;throw e;}).finally(()=>{clearTimeout(timer);abort.signal.removeEventListener('abort',cancel);});
   return loadPromise;
  };
  const normalized=value=>String(value||'').replace(/\s+/g,' ').trim().toLocaleLowerCase();
  const select=(result,link)=>{
   const params=new URL(link.href).searchParams;
   const exact=link.dataset.homeScene;
   const candidates=[...result.data.entries()].filter(([id,d])=>id===exact||id.endsWith('_'+exact));
   let design=candidates.length===1?candidates[0]:null;
   if(!design){
    const matches=[...result.data.entries()].filter(([id,d])=>(!params.get('category')||d.category===params.get('category'))&&normalized(d.text)===normalized(params.get('q'))&&result.photos.some(p=>p.dataset.design===id&&(!params.get('setting')||p.dataset.scene===params.get('setting'))));
    if(matches.length!==1)throw new Error('No unique matching design');
    design=matches[0];
   }
   const [id,d]=design;
   designs=new Map([[id,d]]);
   cards=result.photos.filter(p=>p.dataset.design===id).map(p=>p.cloneNode(true));
   const selected=cards.find(p=>p.dataset.scene===params.get('setting'))||cards.find(p=>p.dataset.photo===d.cover)||cards[0];
   if(!selected)throw new Error('Missing design photo');
   if(link.dataset.detailImage){selected.dataset.full=link.dataset.detailImage;selected.dataset.thumb=link.dataset.detailImage;}
   return selected;
  };
  const open=async link=>{
   opener=link;
   const request=++sequence;
   loading.hidden=false;error.hidden=true;grid.hidden=true;
   dialog.setAttribute('aria-busy','true');
   $('[data-sgi-title]').textContent=link.querySelector('h3')?.textContent||labels.pending;
   $('[data-home-detail-fallback]').href=link.href;
   if(!dialog.open){previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();}
   dialog.scrollTop=0;$('[data-sgi-close]').focus({preventScroll:true});
   try{
    const result=await load();
    if(request!==sequence||!dialog.open||abort.signal.aborted)return;
    showPhoto(select(result,link));
    grid.hidden=false;
   }catch(e){
    if(request===sequence&&dialog.open&&!abort.signal.aborted)error.hidden=false;
   }finally{
    if(request===sequence){loading.hidden=true;dialog.removeAttribute('aria-busy');}
   }
  };
  const prefetch=()=>{load().catch(()=>{});};
  const links=[...home.querySelectorAll('[data-home-scene]')];
  for(const link of links){
   on(link,'click',e=>{if(e.defaultPrevented||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();open(link);});
   on(link,'keydown',e=>{if(e.key===' '){e.preventDefault();open(link);}});
   on(link,'pointerenter',prefetch);on(link,'focus',prefetch);
  }
  let observer;
  if('IntersectionObserver'in window){observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();prefetch();}},{rootMargin:'240px'});observer.observe(home.querySelector('.sg2-sets'));}
  on($('[data-sgi-close]'),'click',()=>dialog.close());
  on(dialog,'click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
  on(dialog,'close',()=>{sequence++;document.documentElement.style.overflow=previousOverflow;dialog.removeAttribute('aria-busy');if(opener?.isConnected)opener.focus({preventScroll:true});});
  on($('[data-home-detail-retry]'),'click',()=>{if(opener)open(opener);});
  on(main,'error',()=>{$('[data-sgi-photo-error]').hidden=false;});
  on(dialog,'keydown',e=>{if(e.target.closest('.sgi-thumbs')&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();const index=cards.indexOf(current);showPhoto(cards[(index+(e.key==='ArrowRight'?1:-1)+cards.length)%cards.length]);$('.sgi-thumbs [aria-pressed="true"]').focus();}});
  on($('[data-sgi-customize]'),'click',()=>{try{const previous=localStorage.getItem('signtasy-customizer-v1');if(previous)localStorage.setItem('signtasy-customizer-before-inspiration',previous);}catch{}});
  on(document,'shopify:section:unload',e=>{if(e.target.contains(root)){sequence++;if(dialog.open)dialog.close();observer?.disconnect();abort.abort();delete root.dataset.ready;}});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
 document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signtasy-small-business"] && !Shopify.designMode) return;
  try {
    (()=>{
 const boot=(scope=document)=>scope.querySelectorAll('[data-sgb-module]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const abort=new AbortController(),on=(el,type,fn)=>el.addEventListener(type,fn,{signal:abort.signal});
  const items=new Map([...root.querySelectorAll('[data-sgb-item]')].map(el=>[el.dataset.sgbItem,el.dataset]));
  const main=root.querySelector('[data-sgb-main]'),frame=root.querySelector('[data-sgb-frame]'),error=root.querySelector('[data-sgb-image-error]');
  const quote=root.querySelector('[data-sgb-quote]'),label=root.querySelector('[data-sgb-scene-label]'),ideas=root.querySelector('[data-sgb-ideas]');
  const route=href=>{const url=new URL(href,location.href),current=new URL(location.href);if(url.origin===current.origin)for(const key of ['preview_theme_id','_ab','_fd','_sc','pb'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));if(url.origin===location.origin&&!url.searchParams.has('preview_theme_id')&&['unpublished','development'].includes(window.Shopify?.theme?.role))url.searchParams.set('preview_theme_id',String(window.Shopify.theme.id));return url;};
  root.querySelectorAll('[data-sgb-route]').forEach(link=>link.href=route(link.href).href);quote.href=route(quote.href).href;
  let chosen='nightcap',sequence=0;
  const select=async key=>{
   const item=items.get(key);if(!item)return;chosen=key;const token=++sequence;error.hidden=true;frame.setAttribute('aria-busy','true');
   const candidate=new Image();candidate.src=innerWidth<768?item.thumb:item.image;
   try{await candidate.decode();if(token!==sequence||abort.signal.aborted)return;
    main.srcset=`${item.thumb} 640w, ${item.image} 1440w`;main.src=item.image;main.alt=item.alt;label.textContent=item.label;
    const url=route(quote.href);url.searchParams.set('view',`business-${key}`);url.searchParams.set('concept',key);quote.href=url.href;
    const gallery=route(ideas.href);gallery.searchParams.set('setting',({nightcap:'bar',beauty:'salon',cycles:'cycle_shop'})[key]||key);ideas.href=gallery.href;
    root.querySelectorAll('[data-sgb-select]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.sgbSelect===key)));
   }catch{if(token===sequence&&!abort.signal.aborted)error.hidden=false;}
   finally{if(token===sequence)frame.removeAttribute('aria-busy');}
  };
  root.querySelectorAll('[data-sgb-select]').forEach(button=>on(button,'click',()=>select(button.dataset.sgbSelect)));
  on(main,'error',()=>{error.hidden=false;});on(root.querySelector('[data-sgb-retry]'),'click',()=>select(chosen));
  const requested=new URL(location.href).searchParams.get('business_concept');if(items.has(requested))select(requested);
  on(document,'shopify:section:unload',event=>{if(event.target.contains(root)){sequence++;abort.abort();}});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
 document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["signtasy-welcome-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{for(const details of document.querySelectorAll('.sg-welcome-offer__terms[open]'))if(!details.contains(event.target))details.open=false;});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')for(const details of document.querySelectorAll('.sg-welcome-offer__terms[open]')){details.open=false;details.querySelector('summary').focus();}});
  (()=>{
    let refreshing=false,lastRefresh=0;
    const applyCustomer=(customerData,ordersCount)=>{
      customerData.textContent=JSON.stringify({ordersCount});
      const offer=document.querySelector('[data-welcome-offer]');
      if(offer){offer.hidden=!offer.hasAttribute('data-custom-neon-offer')&&ordersCount!==null&&ordersCount>0;if(offer.hidden)offer.querySelector('details').open=false;}
      document.dispatchEvent(new CustomEvent('signtasy:customer-orders',{detail:{ordersCount}}));
    };
    const refreshCustomer=async()=>{
      const customerData=document.querySelector('[data-first-order-customer]');
      if(refreshing||document.hidden||!customerData||Date.now()-lastRefresh<1500)return;
      refreshing=true;lastRefresh=Date.now();
      try{
        const url=new URL(window.location.href);url.searchParams.set('_offer_refresh',Date.now().toString());
        const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});
        if(!response.ok)throw new Error('Customer eligibility unavailable');
        const updated=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-first-order-customer]');
        if(!updated)throw new Error('Customer eligibility unavailable');
        const ordersCount=JSON.parse(updated.textContent).ordersCount;
        if(ordersCount!==null&&(!Number.isInteger(ordersCount)||ordersCount<0))throw new Error('Customer eligibility unavailable');
        applyCustomer(customerData,ordersCount);
      }catch{if(JSON.parse(customerData.textContent).ordersCount===0)applyCustomer(customerData,null);}finally{refreshing=false;}
    };
    window.addEventListener('pageshow',event=>{if(event.persisted)window.location.reload();});
    window.addEventListener('focus',refreshCustomer);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshCustomer();});
  })();
  } catch(e) { console.error(e); }
})();

})();
